<template>
  <div class="go-in">
    <div class="banner">
      <div class="banner-img">
        <img src="../assets/img/top2.png" />
      </div>
      <div class="banner-title">
        <p>{{this.$root.language == 1?"走进安仑":"Get to know us"}}</p>
      </div>
    </div>
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary row">
          <div class="col-lg-12 col-md-12 col-ms-12 col-xs-12">
            <div class="summary-left">
              <p class="title wow animate__animated animate__fadeInUp">
                {{this.$root.language == 1?'公司简介':'Company Profile'}}
              </p>
              <p class="eTitle wow animate__animated animate__fadeInUp">
                ABOUT US
              </p>
              <p v-if="this.$root.language == 1" class="content wow animate__animated animate__fadeInUp">
                山西安仑化工有限公司是阳光集团控股子公司，位于山西省运城市河津市僧楼镇河津经济技术开发区东区（华泰西路以东，稷西路以北），是以煤焦油深加工、炭黑生产为主的新能源新材料工业企业。公司于2016年3月份成立，2017年9月份完成重组。公司占地400余亩，现有员工500余人,并设有炭黑研发中心及上海炭黑销售公司。目前下辖炭黑一分厂、炭黑二分厂、炭黑三分厂、动力分厂、精制分厂五个生产分厂。目前拥有年生产能力煤焦油加工72万吨、炭黑45万吨、发电量60MW的生产能力。
              </p>
              <p v-if="this.$root.language != 1" class="content wow animate__animated animate__fadeInUp">
                Shanxi Anlun Chemical Company Ltd. is a subsidiary of the Sunlight Group, located in the eastern area of Hejin Economic and Technological Development Zone, Senglou Town, Hejin City, Yuncheng City, Shanxi Province (east of Huatai West Road and north of Jixi Road).  It is a new energy and new materials industrial company focusing on coal tar deep processing and carbon black production.  The company was formed in March, 2016 and was re-structured in Sept, 2017.  The company occupies over 400 acres of land with over 400 employees, a R&D center, and a sales company in Shanghai.  Manufacturing facility includes carbon black No.1 plant, carbon black No.2 plant, carbon black No.3 plant, power plant, and refining plant.  The annual capacity is 720,000 MT of coal tar processing, 450,000 MT of carbon black, and 60MW of power generation.              </p>
              <p v-if="this.$root.language == 1" class="content wow animate__animated animate__fadeInUp">
                质量、体系认证方面，公司被评为“中国橡胶协会百强企业”、“2021年度中国炭黑十强企业”等称号。是中国橡胶协会炭黑分会主席团成员单位，公司先后通过IATF16949汽车行业质量管理体系、ISO9001质量管理体系、ISO14001环境管理体系、ISO45001职业健康和安全管理体系认证。按照ISO/IEC17025建立的炭黑实验室通过CNAS认证，产品进行了欧盟REACH注册。
              </p>
              <p v-if="this.$root.language != 1" class="content wow animate__animated animate__fadeInUp">
                The company was rated as the top 100 enterprises of the China Rubber Association, top 10 enterprises of China Carbon Black in 2021, and a presidium member of the Carbon Black Branch of the China Rubber Association.  The company also passed the IATF16949 quality management system of the automobile industry, ISO9001 quality management system, ISO14001 environmental management system, ISO45001 occupational health and safety management system certification.  The laboratory was established in accordance with ISO/IEC17025 and passed the CNAS certification.  All products are registered in the European Union REACH.              </p>
            </div>
          </div>
          <!-- <div class="col-lg-6 col-md-12 col-ms-12 col-xs-12">
            <div class="summary-right">
              <img src="../assets/img/bg31.jpg" alt />
            </div>
          </div> -->
        </div>
        <el-divider class="el-divider-active">
          <!-- <i class="el-icon-arrow-down el-icon-arrow-down-active"></i> -->
        </el-divider>
        <!-- 发展历程 -->
        <div class="content-course">
          <div class="top">
            <h3 v-if="this.$root.language == 1" class="wow animate__animated animate__fadeInUp">发展历程</h3>
            <p class="wow animate__animated animate__fadeInUp">DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in courseList" :key="index">
                <div class="time-show">
                  <div
                    class="time-show-item"
                    v-for="(courseOne, one) in item"
                    :key="one"
                  >
                    <div
                      class="item-top"
                      :class="{ 'order-top': one % 2 === 1 }"
                    ></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{ order: one % 2 === 1 }">
                      <div v-if="that.$root.language == 1" class="item-bottom-content">
                        <p v-if="courseOne.Id % 2 === 1" style="font-weight: bolder">{{ courseOne.Year }}</p>
                        <p>{{ courseOne.Content }}</p>
                        <p v-if="courseOne.Id % 2 === 0" style="font-weight: bolder">{{ courseOne.Year }}</p>
                      </div>
                      <div v-if="that.$root.language != 1" class="item-bottom-content">
                        <p v-if="courseOne.Id % 2 === 1" style="font-weight: bolder">{{ courseOne.Year_en }}</p>
                        <p>{{ courseOne.Content_en }}</p>
                        <p v-if="courseOne.Id % 2 === 0" style="font-weight: bolder">{{ courseOne.Year_en }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <!-- <div class="content-culture">
          <h3 class="wow animate__animated animate__fadeInUp">企业使命</h3>
          <span class="wow animate__animated animate__fadeInUp">
            引领碳材料，造福全人类。
          </span>
          <h3 class="wow animate__animated animate__fadeInUp">企业愿景</h3>
          <span class="wow animate__animated animate__fadeInUp"
            >激情工作，快乐生活</span
          >
          <span class="wow animate__animated animate__fadeInUp"
            >成就非凡人生</span
          >
          <span class="wow animate__animated animate__fadeInUp"
            >安仑值得信赖</span
          >
          <span class="wow animate__animated animate__fadeInUp"
            >引领行业发展，为客户提供最佳解决方案</span
          >
        </div> -->
        <!-- 公司荣誉 -->
        <!-- <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <h3 class="wow animate__animated animate__fadeInUp">公司荣誉</h3>
            <p class="wow animate__animated animate__fadeInUp">HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor, index) in honorList" :key="index">
              <img
                class="wow animate__animated animate__fadeInUp"
                v-lazy="honor.Img"
                @click="
                  dialogTableVisible = true;
                  dialogUrl = honor.Img;
                  dialogTitle = honor.Remark;
                "
              />
            </li>
          </ul>
        </div> -->
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3 v-if="this.$root.language == 1" class="wow animate__animated animate__fadeInUp">公司资质</h3>
            <p
              class="wow animate__animated animate__fadeInUp"
              style="padding-bottom: 50px"
            >
              QUALIFICATIONS
            </p>
          </div>
          <el-carousel :height="imgHeight" :interval="4000">
            <el-carousel-item
              style="width: 424px; height: 600px; margin: 0 30%"
              v-for="(team, index) in teamItem"
              :key="index"
            >
              <div
                class="swiper-img"
                v-lazy:background-image="team.Img"
                style="height: 100%"
              ></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 公司荣誉 -->
        <div class="content-hon">
          <div class="top">
            <h3 v-if="this.$root.language == 1" class="wow animate__animated animate__fadeInUp">公司荣誉</h3>
            <p
              class="wow animate__animated animate__fadeInUp"
              style="padding-bottom: 50px"
            >
              HONOR
            </p>
          </div>
          <ul class="ho-show">
            <li v-for="(honor, index) in hoList" :key="index">
              <img
                :src="honor.img"
                @click="
                  dialogTableVisible = true;
                  dialogTitle = honor.Remark;
                "
              />
            </li>
          </ul>
        </div>
        <!-- 合作伙伴 -->
<!--        <div class="content-partner">-->
<!--          <div class="top">-->
<!--            <h3 v-if="this.$root.language == 1" class="wow animate__animated animate__fadeInUp">合作伙伴</h3>-->
<!--            <p class="wow animate__animated animate__fadeInUp">PARTNERS</p>-->
<!--            <div class="partnerImg" style="width: 80%; margin: 0 auto">-->
<!--              <img src="../assets/img/kehu.jpg" style="width: 100%" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    // Banner, 
    swiper,
    swiperSlide,
  },
  data() {
    return {
      that:this,
      loading: false,
      honorList: [
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/IAFA.jpg"),
          Remark: "16949中文证书",
        },
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/honor/EnManageSys.jpg"),
          Remark: "环境管理体系证书",
        },
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/honor/OccManageSys.jpg"),
          Remark: "职业健康管理体系证书",
        },
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/honor/QuaManageSys.jpg"),
          Remark: "质量管理体系证书",
        },
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/honor/Experiment.jpg"),
          Remark: "实验室认可证书",
        },
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/honor/2020TopTen.jpg"),
          Remark: "2020年度中国炭黑十强企业",
        },
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/yyzz.jpg"),
          Remark: "山西安仑化工营业执照",
        },
        {
          CreateTime: "2021-03-26T13:25:19.433",
          Id: 31,
          Img: require("../assets/img/thsq.png"),
          Remark: "2020年度中国炭黑十强企业",
        },
      ],
      hoList: [
        // {
        //   img: require("../assets/img/honor/honor1.png"),
        // },
        {
          img: require("../assets/img/honor/14.png"),
        },
        {
          img: require("../assets/img/honor/15.png"),
        },
        {
          img: require("../assets/img/honor/16.png"),
        },
        {
          img: require("../assets/img/honor/17.png"),
        },
      ],
      partnerImg: [
        {
          Id: 1,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/customer.png"),
          Remark: "合作伙伴",
        },
      ],
      courseList: [],
      teamItem: [
        {
          Id: 1,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/honor/5.jpg"),
          Remark: "实验室认可证书",
        },
        {
          Id: 2,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/honor/6.png"),
          Remark: "标准化良好行为证书",
        },
        // {
        //   Id: 3,
        //     CreateTime: "2021-08-10T01:59:55.71",
        //     Img: require("../assets/img/thsq.png"),
        //     Remark: "2020/2021年度中国炭黑十强企业",
        // },
        {
          Id: 4,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/honor/7.jpg"),
          Remark: "两化融合管理体系评定证书",
        },
        {
          Id: 5,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/honor/8.png"),
          Remark: "环境管理体系证书",
        },
        {
          Id: 6,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/honor/9.png"),
          Remark: "能源管理体系认证证书",
        },
        {
          Id: 7,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/honor/12.png"),
          Remark: "职业健康安全体系认证证书",
        },
        {
          Id: 8,
          CreateTime: "2021-08-10T01:59:55.71",
          Img: require("../assets/img/honor/13.png"),
          Remark: "质量管理体系认证证书",
        },
      ],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      process: [
        {
          Content: "2010年已生产炭黑，前身为山西太兴下属坤盛化工炭黑厂。",
          Content_en:"In 2010, the company began producing carbon black, formerly known as the carbon black plant under Shanxi Taixing Chemical Industry Group.",
          Id: 1,
          Year: "2010年 始建",
          Year_en: "The year of 2010    Set up"
        },
        {
          Content:"2012年2月，山西阳光焦化集团兼并收购山西太兴成立阳光华泰能源有限公司。",
          Content_en:"In February 2012, Shanxi Yangguang Jiaoye Group merged with Shanxi Taixing to form Yangguang Huatai Energy Co., Ltd.",
          Id: 2,
          Year: "2012年 收购",
          Year_en: "The year of 2012    Purchase"
        },
        {
          Content:"2016年3月，山西安仑化工有限公司成立并于2017年9月完成重组。",
          Content_en:"In March 2016, Shanxi Lun Chemical Co., Ltd. was established and restructured in September 2017.",
          Id: 3,
          Year: "2016年 成立",
          Year_en: "The year of 2016    Establish"
        },
        {
          Content: "2017年公司炭黑年产量达到24.84万吨，2023年达到36.4万吨，产量稳步增长。",
          Content_en:"In 2017, the company's annual output of carbon black reached 248,400 tons, and in 2023, it reached 364,000 tons, and the output increased steadily.",
          Id: 4,
          Year: "2017年 产量提高",
          Year_en: "The year of 2017    Yield increase"
        },
        {
          Content: "公司投入大量研发费用，仅2023年试制成功10项新产品，取得15个高新企业专利，3项发明。",
          Content_en:"The company has invested a lot of research and development expenses, and successfully produced 10 new products in 2023, obtained 15 high-tech enterprise patents, and 3 inventions.",
          Id: 5,
          Year: "2023年 持续创新",
          Year_en: "The year of 2023    Continuous innovation"
        },
        {
          Content: "公司未来在提高产量的同时，会拓宽炭黑在液体、导电等方面的应用。",
          Content_en:"In the future, while increasing production, the company will expand the application of carbon black in liquid and conductive fields.",
          Id: 6,
          Year: "未来 拓宽应用",
          Year_en: "Future    Broaden the application"
        },
      ],
      imgHeight: "600px",
    };
  },
  mounted() {
    // console.log("zheli:" + this.$root.language);
    new WOW().init();
    this.$http
      .all([
        this.$http.get("Honor/GetHonorAll"),
        this.$http.get("Enterprise/GetEnterpriseAll"),
        this.$http.get(`Team/GetTeamAll`),
        this.$http.get(`Course/GetCourseAll`),
      ])
      .then(
        this.$http.spread(
          (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
            // this.honorList = responseHonor.data;
            // this.partnerImg = responseEnterprise.data;
            // this.teamItem = responseTeam.data;
            var groupCount = Math.ceil(this.process.length / 2);
            for (let i = 0; i < groupCount; i++) {
              let img2 = [];
              for (let j = 0; j < 2; j++) {
                if (this.process.length - 1 >= i * 2 + j) {
                  img2.push(this.process[i * 2 + j]);
                }
              }
              this.courseList.push(img2);
            }
            this.loading = false;
          }
        )
      );
  },
  methods:{
    // 初始化线形图
    initHistory(){
      this.$http.spread(
          (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
            // this.honorList = responseHonor.data;
            // this.partnerImg = responseEnterprise.data;
            // this.teamItem = responseTeam.data;
            var groupCount = Math.ceil(this.process.length / 2);
            for (let i = 0; i < groupCount; i++) {
              let img2 = [];
              for (let j = 0; j < 2; j++) {
                if (this.process.length - 1 >= i * 2 + j) {
                  img2.push(this.process[i * 2 + j]);
                }
              }
              this.courseList.push(img2);
            }
            this.loading = false;
          }
      )
    },
  },
  // watch:{
  //   '$root.language':{
  //      handler(newVal,oldVar){
  //        console.log(oldVar)
  //        this.$root.language = newVal;
  //        console.log(newVal)
  //      },
  //     deep:true
  //   }
  // }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #eeeeee;
  position: relative;
  overflow: hidden;

  .banner {
    width: 100%;
    height: 300px;
    display: flex;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
      height: 100%;
      width: 100%;
    }
    &-title {
      position: absolute;
      color: #ffffff;
      font-size: 45px;
      font-weight: 400;
      line-height: 300px;
      text-align: center;
      width: 100%;
    }
  }

  .section {
    width: 100%;
    &-content {
      width: 70%;
      margin: 40px auto;
      background-color: rgb(250, 250, 250);
      border: 1px solid #cccccc;
      .content-summary {
        //height: 500px;
        min-height: 650px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        background-image: url("../assets/img/goin_bg.png");
        background-size: cover;
        .summary-left {
          width: 80%;
          margin: 30px auto;
          .title {
            font-size: 25px;
            color: #ee7a18;
          }
          .eTitle {
            font-size: 17px;
            color: #ee7a18;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 16px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 360px;
          height: 310px;
          border: 2px solid #1d42b9;
          animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin: 80px auto;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 80px 0;

        background-image: url("../assets/img/goin_bg2.jpg");
        .course-time {
          width: 90%;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
            .swiper-slide {
              width: 100%;
            }
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 135px;
        .el-carousel {
          .el-carousel__container {
            height: 800px !important;
          }
        }
        .swiper-img {
          height: 800px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .content-honor {
    padding: 50px 0;
    .honor-show {
      width: 90% !important;
    }
  }
}
@media screen and (min-width: 770px) and (max-width: 1199px) {
  .content-course {
    .time-show {
      width: 100% !important;
    }
  }
}
@media screen and (max-width: 769px) {
  .section-content {
    width: 100% !important;
    .content-culture {
      padding-left: 10px !important;
    }
    .content-honor {
      padding: 50px 0;
      .honor-show {
        li {
          margin: 0 auto !important;
        }
      }
    }
    .content-course {
      .time-show {
        width: 100% !important;
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
@keyframes moveTop {
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: #ee7a18;
  height: 5px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #ee7a18;
    border: 3px solid #ee7a18;
    background-color: #ee7a18;
  }
  .el-icon-mobile-phone:before {
    content: none;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
.content-hon {
  padding: 50px 0;
  .ho-show {
    width: 80%;
    margin: 30px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    li {
      width: 46%;
      //height: 320px;
      // margin-left: 15px;
      margin: 20px 10px;
      list-style: none;
      border: 1px solid palegoldenrod;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>